<ng-container *ngIf="vm$ | async as vm">
  <div class="pto-main-container" [ngClass]="{'is-loading':vm.loading}">
    <div class="pto-header-container">
      <span class="pto-header-title">Projects Overview</span>
    </div>
    <div class="spinner-border text-primary summary-question-spinner" role="status" *ngIf="vm.loading"></div>
    <div class="pto-body-container" *ngIf="!vm.loading">
      <app-highlights-and-trends *ngIf="false"></app-highlights-and-trends>
      <app-project-health
        [aggregateValues]="vm.aggregateValues"
        [projectTypes]="vm.projectTypes"
        [filterType]="projectTypeFilter"
        (changeProjectType)="changeProjectType($event)"></app-project-health>
      <app-project-cards *ngIf="!vm.loadingProjects"
        [projectCards]="vm.projects"
        [projectDefaultCategories]="vm.projectDefaultCategories"
        [sortByFilter]="projectSortFilter"
        [filterByIndicator]="projectIndicatorFilter"
        [quickActionData]="vm.quickMenuData"
        (emitPauseOrResumeProject)="openPauseOrResumeProjectModal($event)"
        (sortByChange)="changeProjectSort($event)"
        (indicatorSortEvent)="changeProjectIndicatorSort($event)"
        (emitGoToDashboard)="goToProjectDashboard($event)"
        (loadQuickActionMenuData)="loadQuickActionsMenuData($event)"></app-project-cards>
    </div>
  </div>
</ng-container>
